module.exports = __webpack_public_path__ + "img/content-copy.d65dbb51.svg";